import {
  Box,
  Icon,
  Icons,
  Stack,
  Typography,
} from '@nextiva/next-ui-components';
import React from 'react';
import { EnablementField } from 'interface/WizardV3';
import { useWizardContextV3 } from './WizardContextV3/WizardContextV3';

const dataTestId = 'PlatformAdminUI-Messaging-CampaignDialog';

function StepsItems({
  title,
  isSelected,
  value,
  fields = [],
}: {
  title: string;
  isSelected: boolean;
  value: number;
  fields: EnablementField[];
}) {
  const {
    handleSetStep,
    formState: { errors },
    state: { visitedSteps },
    declinedWithBrandVerified,
  } = useWizardContextV3();
  const brandVerified = declinedWithBrandVerified && value === 1;
  const visited = visitedSteps.includes(value);
  const errorPresent = fields.some((field) => !!errors[field]);
  return (
    <Stack
      component="div"
      data-testid={`${dataTestId}-Left-Items`}
      onClick={() => handleSetStep(value)}
      paddingLeft="2rem"
      height="48px"
      mr="24px"
      sx={{
        padding: '12px 24px 12px 48px',
        background: isSelected ? '#EAEBEF' : '',
        cursor: 'pointer',
      }}
    >
      <Box
        display="flex"
        component="span"
        justifyContent="space-between"
        width="100%"
        alignItems="center"
      >
        {title && (
          <Typography
            variant="body1"
            component="span"
            sx={{
              fontWeight: isSelected ? 800 : 500,
              display: 'inline-block',
              marginLeft: '8px',
              overflow: 'hidden',
              textAlign: 'left',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {title}
          </Typography>
        )}
        {(visited || brandVerified) && (
          <Box display="flex">
            {!brandVerified && errorPresent ? (
              <Icon
                icon={Icons.exclamationSolid}
                size={16}
                sx={{
                  color: 'deepOrange.900',
                  alignSelf: 'center',
                }}
              />
            ) : (
              <Icon
                icon={Icons.checkCircleSolid}
                size={16}
                sx={{
                  color: 'teal.700',
                  alignSelf: 'center',
                }}
              />
            )}
          </Box>
        )}
      </Box>
    </Stack>
  );
}

export default StepsItems;
